import React from 'react';
import { HeadingMedium } from '@ajat/design-system/Configurator';
import DynamicAttributeControls from '../../Common/Product/DynamicAttributeControls';

/**
 * CLS-DK add-ons block ("Tilføjelser").
 *
 * Only the BE-driven dynamic attributes (non-color, non-size) are rendered
 * here now — the former hardcoded fields (Navnetryk, Speciel tekst, Flag,
 * Klassens bogstav, Lille Brysttryk, Rygtryk) are hidden; everything shown in
 * this section comes from product Attributes. Revealed once a size is picked.
 */
const CLSAddons = ({
  visible,
  dynamicAttributes = [],
  selectedAttributes = {},
  onAttributeChange,
  onAttributeFocus,
  openFocusMode,
  isMobile = false,
  onAttributeBlur,
  typingMode = false,
  onTypingChange,
  onInfoOpen,
  disabledValueIdsByAttribute = {},
  hiddenControlSlugs = new Set(),
  unavailableLinked = {},
  showRequiredErrors = false,
  requiredEmptySlugs = new Set(),
  requiredErrorText = 'Udfyld venligst dette felt',
}) => {
  if (!visible) return null;

  const hiddenSet = hiddenControlSlugs instanceof Set ? hiddenControlSlugs : new Set(hiddenControlSlugs || []);
  // Nothing to show when there are no dynamic (non-color, non-size, non-hidden) attributes.
  const dynamicItems = (dynamicAttributes || []).filter(
    (a) => a.slug !== 'color' && a.slug !== 'size' && a.type !== 'color' && !hiddenSet.has(a.slug),
  );
  if (dynamicItems.length === 0) return null;

  return (
    <div className="pp__addons-reveal">
      <HeadingMedium title="Tilføjelser" />

      <DynamicAttributeControls
        attributes={dynamicItems}
        selectedAttributes={selectedAttributes}
        onAttributeChange={onAttributeChange}
        onAttributeFocus={onAttributeFocus}
        openFocusMode={openFocusMode}
        isMobile={isMobile}
        onAttributeBlur={onAttributeBlur}
        typingMode={typingMode}
        onTypingChange={onTypingChange}
        onInfoOpen={onInfoOpen}
        disabledValueIdsByAttribute={disabledValueIdsByAttribute}
        hiddenControlSlugs={hiddenSet}
        unavailableLinked={unavailableLinked}
        showRequiredErrors={showRequiredErrors}
        requiredEmptySlugs={requiredEmptySlugs}
        requiredErrorText={requiredErrorText}
      />
    </div>
  );
};

export default CLSAddons;
